<template>
  <CommonPages id="privacy" class="privacy common-text" headerTheme="dark"
    titlePrefix="Privacy Policy">
    <div class="common-text__container">
      <div class="common-text__content pc_padding">
        <h1 class="common-text__title">Privacy Policy</h1>

        <div class="common-text__section">
          <p class="common-text__paragraph">
            Welcome to {{ domainConfig?.IAmURL }}. We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">1. Information We Collect</h2>
          <p class="common-text__paragraph">
            <strong>Personal Information:</strong> We may collect personal details such as your name, email address, and contact information when you register or contact us.
            <br><br>
            <strong>Usage Data:</strong> We collect information about how you use our website, including your IP address, browser type, and pages visited.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">2. How We Use Your Information</h2>
          <p class="common-text__paragraph">
            To provide and improve our services.
            <br><br>
            To communicate with you and respond to inquiries.
            <br><br>
            To analyze usage and improve website functionality.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">3. Sharing Your Information</h2>
          <p class="common-text__paragraph">
            We do not sell or rent your personal information to third parties. We may share information with trusted partners to help us operate the website and provide our services, subject to confidentiality agreements.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">4. Cookies</h2>
          <p class="common-text__paragraph">
            Our website uses cookies to enhance user experience. You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can modify your browser setting to decline cookies if you prefer.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">5. Data Security</h2>
          <p class="common-text__paragraph">
            We implement appropriate technical and organizational measures to protect your personal data from unauthorized access, use, or disclosure.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">6. Third-Party Links</h2>
          <p class="common-text__paragraph">
            Our website may contain links to external sites. We are not responsible for the privacy practices of these sites and encourage you to review their privacy policies.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">7. Your Rights</h2>
          <p class="common-text__paragraph">
            You have the right to access, correct, or delete your personal information. To exercise these rights, please contact us at {{ domainConfig?.IAMEMAIL }}.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">8. Changes to This Policy</h2>
          <p class="common-text__paragraph">
            We may update this Privacy Policy from time to time. Changes will be posted on this page, and we encourage you to review it regularly.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">9. Contact Us</h2>
          <p class="common-text__paragraph">
            If you have any questions or concerns about this Privacy Policy, please contact us at {{ domainConfig?.IAMEMAIL }}.
          </p>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Privacy',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'domainConfig'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.common-text {
	background: #000;
	min-height: 100vh;

	&__content {
		margin: 0 auto;
		padding: rem(60) rem(120);
		width: 100%;
	}

	&__title {
		color: #fff;

		font-size: rem(24);
		font-weight: 700;
		line-height: rem(24);
		margin-bottom: rem(24);
	}

	&__section {
		margin-bottom: rem(40);
	}

	&__section-title {
		color: #fff;

		font-size: rem(24);
		font-weight: 700;
		line-height: rem(28);
		margin-bottom: rem(16);
	}

	&__subsection-title {
		color: #fff;

		font-size: rem(18);
		font-weight: 600;
		line-height: rem(24);
		margin-top: rem(20);
		margin-bottom: rem(12);
	}

	&__paragraph {
		color: rgba(255, 255, 255, 0.60);

		font-size: rem(12);
		font-weight: 400;
		line-height: rem(24);
		margin-bottom: rem(16);
	}

	&__link {
		color: var(--theme-color);
		text-decoration: underline;
		text-decoration-thickness: auto;
		text-decoration-style: solid;
		text-decoration-skip-ink: none;

		&:hover {
			opacity: 0.8;
		}
	}

	&__list,
	&__numbered-list {
		color: #777;

		font-size: rem(14);
		font-weight: 400;
		line-height: rem(24);
		margin-bottom: rem(16);
		padding-left: rem(20);
	}

	&__list {
		list-style-type: disc;
	}

	&__numbered-list {
		list-style-type: decimal;
	}

	&__list-item,
	&__numbered-list-item {
		margin-bottom: rem(8);

		&:last-child {
			margin-bottom: 0;
		}
	}

	&__table {
		width: 100%;
		border-collapse: collapse;
		margin-bottom: rem(20);

		font-size: rem(14);

		th,
		td {
			border: 1px solid #e9e9e9;
			padding: rem(10) rem(16);
			text-align: left;
		}

		th {
			background-color: #f5f7fa;
			color: #141414;
			font-weight: 600;
		}

		td {
			color: #777;
		}
	}

	&__blockquote {
		border-left: 4px solid #405ff2;
		padding: rem(16) rem(20);
		background-color: #f5f7fa;
		margin: rem(16) 0;
		color: #777;

		font-size: rem(14);
		font-style: italic;
		line-height: rem(24);
	}

	&__code-block {
		background-color: #f5f7fa;
		border-radius: rem(8);
		padding: rem(16);
		margin: rem(16) 0;
		overflow-x: auto;

		pre {
			margin: 0;

			code {
				color: #777;
				font-size: rem(14);
				line-height: 1.5;
			}
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.common-text {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);

		&__title {
			font-size: rem(24);
			line-height: rem(24);
		}

		&__section-title {
			font-size: rem(16);
			line-height: rem(24);
		}
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.common-text {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);

		&__content {
			padding: 0 rem(16);
		}

		&__content {
			max-width: rem(343);
			padding: rem(20);
		}

		&__title {
			font-size: rem(24);
			line-height: rem(24);
			margin-bottom: rem(20);
		}

		&__section-title {
			font-size: rem(16);
			font-style: normal;
			font-weight: 900;
			line-height: rem(24); /* 150% */
			margin-bottom: rem(8);
		}

		&__subsection-title {
			color: #141414;

			font-size: rem(12);
			font-weight: 600;
			line-height: rem(24);
			margin-top: rem(16);
			margin-bottom: rem(8);
		}

		&__paragraph {
			color: #777;

			font-size: rem(12);
			font-weight: 400;
			line-height: rem(24);
			margin-bottom: rem(8);
		}

		&__list,
		&__numbered-list {
			font-size: rem(12);
			line-height: rem(24);
			margin-bottom: rem(12);
		}

		&__list-item,
		&__numbered-list-item {
			margin-bottom: rem(6);
		}

		&__blockquote {
			font-size: rem(12);
			padding: rem(12) rem(16);
			margin: rem(12) 0;
		}

		&__table {
			font-size: rem(12);

			th,
			td {
				padding: rem(8) rem(12);
			}
		}
	}
}
</style>